import CustomCheckbox from './CustomCheckbox';

export default CustomCheckbox;
